/*!
 * Project: bicc-assets
 * Author: Rolf Alberth <rolf.alberth@bicc.de>
 * Last Modified: 2022-10-12 12:42:26
 * License: MIT License
 */


// Styles
import './css/base.scss'
import './css/extra.pcss'

// We use these Bootstrap components
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/offcanvas'
import 'bootstrap/js/dist/scrollspy'


// Navbar
const bodyElement = document.body || document.querySelector('body')
const navbarMain = document.querySelector('.navbar-main')

// Scolling
const scollTrigger = document.querySelector('.compact-trigger')
if (scollTrigger) {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio > 0) {
            bodyElement.classList.remove("start-left")
        } else {
            bodyElement.classList.add("start-left")
        }
    })
    observer.observe(scollTrigger)
}

if (navbarMain) {
    navbarMain.addEventListener('transitionend', () => {
        if (bodyElement.classList.contains('start-left')) {
            navbarMain.classList.add('solid')
        } else {
            navbarMain.classList.remove('solid')
        }
    })
}


// Linked cards
for (const node of document.querySelectorAll('.card-linked')) {

    const href = node.getAttribute('data-href')
    const main = node.querySelector('.main-link')
    if (href || main) {
        node.classList.add('card-clickable')
    }

    node.addEventListener('click', function () {
        const isSelected = window.getSelection().toString()
        if (!isSelected) {
            const href = node.getAttribute('data-href')
            if (href) {
                document.location.href = href
            } else {
                if (main) {
                    main.click()
                }
            }
        }
    })

}


export default {}